<template>
  <div
    v-vpshow
    class="publication"
  >
    <!-- <NuxtLink class="publication-link" :class="{hide: activeArticle !== 0}" v-if="data.link" :to="getUrl(data.link.url)">
      <div class="article-info">
        <div class="chevron"></div>
        <div class="article-title">{{ data.link_title }}</div>
      </div>
    </NuxtLink> -->
    <div ref="articles" class="articles">
      <div
        v-for="(article, index) in chapters"
        :key="index"
        class="article"
        :style="[{backgroundColor: article.background_color}, {zIndex: chapters.length - index}]"
        :class="[currentClass(index), {first: index === 0}, {last: index === chapters.length - 1}]"
        v-on="index !== activeArticle ? { click: () => setQuery(index) } : {}"
      >
        <div class="article-inner">
          <!-- Modules -->
          <Component
            :is="module.acf_fc_layout.charAt(0).toUpperCase() + module.acf_fc_layout.slice(1)"
            v-for="(module, subindex) in article.modules"
            :key="subindex"
            :data="module"
            :prev="article.modules[subindex-1]"
            :next="article.modules[subindex+1]"
            :module-type="module.acf_fc_layout.toLowerCase()"
          />
          <!-- Index-->
          <div v-if="index === 0" class="index wrapper">
            <div class="left">
              <Vid v-if="data.video" :data="{ file: data.video, autoplay: true }"></Vid>
              <Img v-else-if="data.image" :data="data.image"></Img>
            </div>
            <div class="right">
            <h2>Index</h2>
              <ul>
                <li
                  v-for="(article, index) in chapters.slice(1, chapters.length)"
                  :key="'index-' + index"
                  @click="setQuery(index + 1)"
                >
                  <span class="index-number">{{ ('0' + (index + 1)).slice(-2) }}</span><span class="index-title">{{ article.title }}</span><div v-if="article.description" class="index-description">{{ article.description }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="article-info">
          <div class="chevron"></div>
          <div class="article-index" v-if="index !== 0">{{ ('0' + index).slice(-2) }}</div>
          <div class="article-title">{{ article.title }}</div>
        </div>
        <div class="mobile-info" v-if="index !== 0">
          <div class="mobile-info-content">
            <div class="mobile-back" @click="setQuery(index - 1)"><div class="chevron"></div>Back</div>
            <div class="mobile-current">
              <div class="article-index">{{ ('0' + index).slice(-2) }}</div>
              <div class="article-title">{{ article.title }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '@/mixins/utils'
import Wysiwyg from '@/components/modules/Wysiwyg'
import Singleimage from '@/components/modules/Singleimage'
import Video from '@/components/modules/Video'
import Motion from '@/components/modules/Motion'
import Headline from '@/components/modules/Headline'
import Galleryv2 from '@/components/modules/Galleryv2'
import Space from '@/components/modules/Space'
import Section from '@/components/modules/Section'
import Quote from '@/components/modules/Quote'
import Audio from '@/components/modules/Audio'
import List from '@/components/modules/List'
import Button from '@/components/modules/Button'
import Linklist from '@/components/modules/Linklist'
import Promov2 from '@/components/modules/Promov2'
import Layout from '@/components/modules/Layout'
import Img from '@/components/Img'
import Vid from '@/components/Vid'
export default {
  name: 'Publication',
  mixins: [utils],
  components: {
    Wysiwyg,
    Singleimage,
    Motion,
    Headline,
    Galleryv2,
    Space,
    Section,
    Quote,
    Audio,
    List,
    Linklist,
    Promov2,
    Layout,
    Video,
    Button,
    Img,
    Vid
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      activeArticle: 0,
      highlight: null,
      indexOpen: false
    }
  },
  computed: {
    chapters() {
      return this.data.chapters && this.data.chapters.length > 0
        ? [{title: 'Index'}, ...this.data.chapters]
        : this.data.article
    },
    testing() {
      return '60vw'
    },
    isMobile() {
      return this.$mq === 'tiny' || this.$mq === 'mobile'
    }
  },
  watch: {
    '$route.query.chapter'(newVal) {
      if (newVal) {
        this.setActiveArticle(newVal - 1)
      } else {
        this.setActiveArticle(0)
      }
    }
  },
  mounted() {
    if (this.$route.query.chapter) {
      this.setActiveArticle(this.$route.query.chapter - 1)
    }
  },
  methods: {
    articlePosition(index) {
      const perc = index / (this.chapters.length - 1)
      const offset = 1 / (this.chapters.length - 1)
      if (index < this.activeArticle) {
        return (
          'calc((100vw - ' +
          ' - 50vw) *' +
          perc +
          ' - 100% + (100vw - ' +
          ' - 50vw) *' +
          offset +
          ')'
        )
      } else {
        return 'calc((100vw - 50vw) *' + perc + ')'
      }
    },
    articlePositionCurrent(index) {
      const perc = index / (this.chapters.length - 1)
      return 'calc((100vw - 50vw) *' + perc + ')'
    },
    setQuery(index) {
      this.$router.push({
        path: this.$route.path,
        query: Object.assign({}, this.$route.query, {
          chapter: index + 1
        })
      })
    },
    setActiveArticle(index) {
      this.activeArticle = index
      this.indexOpen = false
      // const el = this.$refs.articles.children[index]
      // if (el.scrollTop < 10) {
      //   el.scrollTop = el.scrollTop + 1
      // } else {
      //   el.scrollTop = el.scrollTop - 1
      // }
    },
    highlightArticle(index) {
      this.highlight = index
    },
    clearHighlight() {
      this.highlight = null
    },
    // handleScroll: function(el) {
    //   if (
    //     el.srcElement.offsetHeight + el.srcElement.scrollTop >=
    //     el.srcElement.scrollHeight
    //   ) {
    //     if (this.activeArticle < this.chapters.length - 1) {
    //       this.setActiveArticle(this.activeArticle + 1)
    //     }
    //   }
    //   if (el.srcElement.scrollTop <= 0) {
    //     if (this.activeArticle > 0) {
    //       this.setActiveArticle(this.activeArticle - 1)
    //     }
    //   }
    // },
    currentClass(index) {
      if (index === this.activeArticle - 1) {
        return 'prev'
      } else if (index === this.activeArticle) {
        return 'current'
      } else if (index === this.activeArticle + 1) {
        return 'next'
      } else if (index < this.activeArticle - 1) {
        return 'hide hide-left'
      } else if (index > this.activeArticle + 1) {
        return 'hide hide-right'
      }
    },
    toggleIndex() {
      this.indexOpen = true
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  @include grid-container-responsive;

  .left {
    grid-column: full / span 7;

    @include media($small) {
      @include grid-item(12, 1);
    }

    @include media($mobile) {
      grid-column: full / span 8;
    }
  }
  .right {
    @include fluid-prop(padding-top, 20px, 50px);
    @include grid-item(6, 8);
    @include media($small) {
      @include grid-item(12, 1);
    }

    @include media($mobile) {
      @include grid-item(6, 1);
    }
  }
}
.publication {
  position: relative;
  width: 100vw !important;
  height: calc(100dvh - 89px);
  transform: none !important;
  overflow: hidden;
  margin-bottom: -1px;
  --closed-width: 66px;
  @include media($mobile) {
    --closed-width: 50px;
    height: calc(100dvh - 79px) !important;
  }
  ::v-deep video {
    display: block;
  }
}

h2 {
  @include fontsize(50);
  text-transform: uppercase;
  @include fluid-prop(margin-bottom, 40px, 80px);
  font-family: adobe-garamond-pro;

  @include media($mobile) {
    @include fontsize(30);
  }
}

ul {
  font-family: adobe-garamond-pro;

  li {
    margin-bottom: 40px;
    cursor: pointer;
  }
}
.publication-link {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: var(--closed-width);
  z-index: 2;
  background: #fff;
  transition: all 1200ms $easeInOutExpo;
  @include media($mobile) {
    display: none;
  }
  .chevron {
    opacity: 1;
    transform: translateY(-50%) rotate(180deg);
  }
  &.hide {
    transform: translateX(-100%);
  }
}
.articles {
  z-index: 1;
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100%;
  border-top: 1px solid $line-color;
  border-bottom: 1px solid $line-color;
  margin-bottom: -1px;;
}
.menu-wrapper {
  position: relative;
  .menu-preloader {
    position: absolute;
    width: 100%;
    top: 40px;
    text-align: center;
    transition: opacity 100ms;
    img {
      margin: 0 auto;
    }
  }
  ul {
    opacity: 0;
    pointer-events: none;
    transition: opacity 100ms ease-out 200ms;
  }
}
.article-info {
  position: sticky;
  top: 0;
  left: 100%;
  height: calc(100dvh - 90px);
  width: var(--closed-width);
  z-index: 10;
  @include fontsize(25);
  font-family: adobe-garamond-pro;
  pointer-events: none;

  @include media($mobile) {
    @include fontsize(20);
  }
  .chevron {
    position: absolute;
    right: 20px;
    top: calc(50% - 2px);
    font-size: 150%;
    transform: translateY(-50%);
    transition: 100ms ease-in-out;
    transform-origin: center;
    background-image: url("~/assets/img/arrow-right.png");
    background-size: 25px;
    background-repeat: no-repeat;
    width: 25px;
    height: 25px;
    opacity: 0;
    @include media($mobile) {
      right: 12px;
    }
  }
  .article-index {
    text-align: center;
    width: calc(100% - 40px);
    margin: 0 20px;
    padding: 20px 0;
    border-top: 1px solid $black;
    position: absolute;
    bottom: 0;
    @include media($mobile) {
      border-top: none;
      margin: 0 10px;
      padding: 9px 0;
      width: calc(100% - 20px);
    }
  }
  .article-title {
    position: absolute;
    bottom: 70px;
    transform: rotate(-90deg);
    left: 15px;
    transform-origin: left top;
    white-space: nowrap;

    @include media($mobile) {
      left: 12px;
      bottom: 50px;
    }
  }

  @include media($small) {
    height: calc(100dvh - 80px);
  }
}
.mobile-info {
  display: none;
  @include media($mobile) {
    @include fontsize(20);
    display: block;
    position: sticky;
    top: calc(100dvh - 120px);
    height: 40px;
    left: 0;
    width: 100%;
    background: $main-color;
    z-index: 20;
    border-top: 1px solid $line-color;
    transform: translateY(100%) !important;
    transition: transform 500ms $easeOutExpo;

    .current & {
      transition-delay: 500ms;
      transform: translateY(0) !important;
    }
  }
  .mobile-info-content {
    width: calc(100% - 40px);
    height: 100%;
    display: flex;
    position: absolute;
    left: 20px;
    align-items: center;
    justify-content: space-between;
    font-family: adobe-garamond-pro;

    .article-index {
      margin-right: 10px;
      padding-left: 20px;
      border-left: 1px solid $line-color;
    }
  }
  .mobile-back {
    display: flex;
    align-items: center;
    .chevron {
      background-image: url("~/assets/img/arrow-right.png");
      background-size: 25px;
      background-repeat: no-repeat;
      width: 20px;
      height: 25px;
      transform: rotate(180deg);

      @include media($mobile) {
        right: 12px;
      }
    }
  }
  .mobile-current {
    display: flex;
    align-items: center;
  }
}
.article {
  background: #fff;
  width: calc(100vw - (2 * var(--closed-width)));
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  transition: all 1200ms $easeInOutExpo;
  cursor: pointer;
  &.last {
    width: calc(100vw - var(--closed-width));

    @include media($mobile) {
      width: 100vw;
    }
  }
  &.first {
    width: calc(100vw - var(--closed-width));
    @include media($mobile) {
      width: calc(100vw - var(--closed-width));
    }
  }

  @include media($mobile) {
    width: calc(100vw - var(--closed-width));
  }
  &.highlight {
    left: 15px;
    @include media($mobile) {
      left: 0;
    }
  }
  ::v-deep .module {
    background-color: transparent !important;
  }
  &.current {
    background-color: $main-color !important;
    overflow: scroll;
    cursor: auto;
    transform: translateX(var(--closed-width)) !important;

    &.first {
      transform: translateX(0) !important;
    }

    @include media($mobile) {
      transform: translateX(0) !important;
    }

    .article-inner {
      pointer-events: auto;
      @include media($mobile) {
        padding: 0;
      }
    }
    .article-info {
      @include media($mobile) {
        display: none;
      }
    }
  }
  &.prev {
    .chevron {
      opacity: 1;
      transform: translateY(-50%) rotate(180deg);
    }
    transform: translateX(calc(-100% + var(--closed-width))) !important;
    @include media($mobile) {
      transform: translateX(-100%) !important;
    }
  }
  &.next {
    .chevron {
      opacity: 1;
    }
    transform: translateX(calc(2 * var(--closed-width))) !important;
    &.last {
      transform: translateX(calc(var(--closed-width))) !important;

      @include media($mobile) {
        transform: translateX(0) !important;
      }
    }
    @include media($mobile) {
       transform: translateX(var(--closed-width)) !important;
    }
  }
  &.hide {
    &.hide-left {
      transform: translateX(-100%) !important;
    }
    &.hide-right {
      transform: translateX(calc(3 * var(--closed-width))) !important;
    }
    @include media($small) {
      display: none;
    }
  }
  .article-inner {
    width: 100%;
    float: right;
    transition: opacity 200ms;
    padding: 0 var(--closed-width) 0 0;
    position: relative;
    pointer-events: none;
  }
}
.index-title,
.index-number {
  font-weight: 500;
  @include fontsize(25);
  text-transform: uppercase;
  @include media($mobile) {
    @include fontsize(20);
  }
}
.index-number {
  display: inline-block;
  width: 40px;
  @include media($mobile) {
    width: 25px;
  }
}
.index-description {
  padding-left: 40px;
  @include fontsize(25);
  @include media($mobile) {
    padding-left: 25px;
    @include fontsize(20);
  }
}
.title {
  @include fontsize(30);
  text-align: center;
  font-family: adobe-garamond-pro;
}
.description {
  @include fontsize(20);
  text-align: center;
  font-family: adobe-garamond-pro;
  font-style: italic;
  margin-bottom: 30px;
}
.logo {
  text-align: center;
  margin-bottom: 20px;
  svg,
  img {
    max-width: 80px;
    height: auto;
  }
}
</style>
